import { createTheme } from '@mui/material';

export default (environment: 'local' | 'dev' | 'prod') =>
  createTheme({
    spacing: 4,
    palette: {
      primary: {
        main: environment === 'dev' ? '#61C100' : environment === 'prod' ? '#0094FF' : '#E000C9',
      },
    },
  });
